import { render, staticRenderFns } from "./edition-title-bar.vue?vue&type=template&id=5fd9a9d8"
import script from "./edition-title-bar.vue?vue&type=script&lang=js"
export * from "./edition-title-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports